import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { useUserContext } from '../../../contexts/UserContext';
import { permission } from '../../../config/permission';
import { EPMContextProvider } from '../../../contexts/EPMContext';
import Home from '../../../components/EPM/Home';
import Learnings from '../../../components/EPM/Learnings';
import Schedule from '../../../components/EPM/Schedule';
import Settings from '../../../components/EPM/Settings';
import TestingBoard from '../../../components/EPM/TestingBoard';
import TestWorkflow from '../../../components/EPM/TestWorkflow';
import TestDetails from '../../../components/EPM/TestDetails';

const EPM = () => {
    const { checkPermission } = useUserContext();

    const canViewTests = checkPermission(permission.XCM_TESTS_VIEW);
    const canViewSchedule = checkPermission(permission.XCM_SCHEDULE_VIEW);
    const canViewLearnings = checkPermission(permission.XCM_LEARNINGS_VIEW);
    const canViewSettings = checkPermission(permission.XCM_SETTINGS_VIEW);

    return (
        <div className="w-full">
            <EPMContextProvider>
                <Routes>
                    <Route path="/home"          element={<Home />} />
                    <Route path="/testing-board" element={canViewTests ? <TestingBoard /> : <Navigate to="/epm/home" replace />} />
                    <Route path="/schedule"      element={canViewSchedule ? <Schedule /> : <Navigate to="/epm/home" replace />} />
                    <Route path="/learnings"     element={canViewLearnings ? <Learnings /> : <Navigate to="/epm/home" replace />} />
                    <Route path="/settings"      element={canViewSettings ? <Settings /> : <Navigate to="/epm/home" replace />} />
                    <Route path="/test-workflow/:id" element={canViewTests ? <TestWorkflow /> : <Navigate to="/epm/home" replace />} />
                    <Route path="/test/details/:id" element={canViewTests ? <TestDetails /> : <Navigate to="/epm/home" replace />} />
                    <Route path="*"              element={<Navigate to="/epm/home" replace />} />
                </Routes>
            </EPMContextProvider>
        </div>
    );
};

export default EPM;
